import React from 'react';
import { Loader, Plus, X } from 'react-feather';

import { KeywordManageModalProps } from '@/Keyword/types/keywordTypes';
import { useKeywordManage } from '../../hooks/useKeywordManage';

const KeywordManageModal: React.FC<KeywordManageModalProps> = ({
  isOpen,
  onClose,
  selectedKeywordId,
}) => {
  const {
    groupName,
    keywordList,
    isLoading,
    isSaving,
    isDeleting,
    handleGroupNameChange,
    handleKeywordChange,
    handleAddKeyword,
    handleRemoveKeyword,
    handleSave,
    handleDelete,
    canDeleteKeyword,
    canSave,
  } = useKeywordManage(selectedKeywordId || null, onClose);

  const isEdit = selectedKeywordId !== null && selectedKeywordId !== undefined;

  console.log(selectedKeywordId, 'sadlkjfa');

  if (!isOpen) return null;

  // 로딩 상태
  if (isLoading) {
    return (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          role="button"
          tabIndex={0}
          onClick={onClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClose();
            }
          }}
          aria-label="Close modal"
        />

        <div
          className="relative z-50 w-full max-w-lg rounded bg-white shadow-lg"
          role="document"
        >
          <div className="flex h-40 items-center justify-center">
            <Loader className="animate-spin text-gray-500" size={24} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        className="fixed inset-0 bg-black bg-opacity-50"
        role="button"
        tabIndex={0}
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClose();
          }
        }}
        aria-label="Close modal"
      />

      <div
        className="relative z-50 w-full max-w-lg rounded bg-white shadow-lg"
        role="document"
      >
        <div className="flex items-center justify-between px-6 py-4">
          <div className="flex flex-1 items-center space-x-2">
            <input
              type="text"
              id="modal-title"
              className="w-2/3 rounded border border-[#CCCCCC] px-3 py-2 text-sm focus:opacity-80 focus:outline-none"
              placeholder="Keyword Group Name"
              aria-label="Keyword group name"
              value={groupName}
              onChange={(e) => handleGroupNameChange(e.target.value)}
              disabled={isSaving || isDeleting}
            />
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ml-4 text-[#707070] hover:opacity-80"
            aria-label="Close modal"
            disabled={isSaving || isDeleting}
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="bg-[#F1F1F1] px-6 pt-6" role="form">
          <div className="space-y-4">
            <div className="space-y-4">
              <label
                id="keyword-list-label"
                htmlFor="keyword-list"
                className="font-medium"
              >
                Keyword list
              </label>
              <div
                className="space-y-2"
                role="group"
                aria-labelledby="keyword-list-label"
              >
                {keywordList.map((keyword, index) => (
                  <div
                    // eslint-disable-next-line react/no-array-index-key
                    key={`keyword-${index}`}
                    className="flex items-center justify-start"
                  >
                    <input
                      type="text"
                      className="w-2/3 rounded border border-[#CCCCCC] px-3 py-2 text-sm focus:opacity-80 focus:outline-none"
                      placeholder="Enter keyword"
                      value={keyword}
                      onChange={(e) =>
                        handleKeywordChange(index, e.target.value)
                      }
                      aria-label={`Keyword ${index + 1}`}
                      disabled={isSaving || isDeleting}
                    />
                    {canDeleteKeyword(index) && (
                      <button
                        type="button"
                        onClick={() => handleRemoveKeyword(index)}
                        className="ml-2 rounded-[4px] bg-white p-2 text-[#707070] hover:opacity-80"
                        aria-label={`Remove keyword ${index + 1}`}
                        disabled={isSaving || isDeleting}
                      >
                        <X className="h-4 w-4" />
                      </button>
                    )}
                  </div>
                ))}

                <button
                  type="button"
                  onClick={handleAddKeyword}
                  className="flex w-2/3 items-center justify-center rounded border border-[#CCCCCC] bg-[#DEDEDE] py-2 text-sm outline-none hover:opacity-80"
                  aria-label="Add new keyword"
                  disabled={isSaving || isDeleting}
                >
                  <Plus className="mr-1 h-4 w-4 text-[#707070]" />
                </button>
              </div>
            </div>
          </div>

          <div
            className="mt-6 flex justify-end space-x-2 pb-6"
            role="group"
            aria-label="Modal actions"
          >
            <button
              type="button"
              onClick={handleSave}
              className="flex items-center rounded bg-[#3E3E3E] px-3 py-1 text-sm font-medium text-white hover:opacity-80 disabled:opacity-50"
              aria-label="Save keyword group"
              disabled={!canSave || isSaving || isDeleting}
            >
              {isSaving && <Loader className="mr-1 h-3 w-3 animate-spin" />}
              Save
            </button>
            {isEdit && (
              <button
                type="button"
                onClick={handleDelete}
                className="flex items-center rounded bg-[#8F1A1A] px-3 py-1 text-sm font-medium text-white hover:opacity-80 disabled:opacity-50"
                aria-label="Delete keyword group"
                disabled={isSaving || isDeleting}
              >
                {isDeleting && <Loader className="mr-1 h-3 w-3 animate-spin" />}
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeywordManageModal;
